{
  "nav": {
    "group": {
      "klubhus": "Clubhouse",
      "planlaegning": "Planning",
      "marked": "Market",
      "resultater": "Results",
      "min": "My",
      "accountHelp": "Account & help",
      "admin": "Admin"
    },
    "item": {
      "dashboard": "Dashboard",
      "team": "My Team",
      "u23Team": "U23 team",
      "juniorTeam": "Junior team",
      "training": "Daily Training",
      "planning": "Planning",
      "academy": "Academy",
      "scouting": "Scouting",
      "board": "Board",
      "sponsors": "Sponsors",
      "finance": "Finance",
      "klub": "Club",
      "notifications": "Inbox",
      "forum": "Forum",
      "managerProfile": "My Manager Profile",
      "riders": "Riders",
      "auctions": "Auctions",
      "transfers": "Transfers",
      "transferList": "Transfer list",
      "watchlist": "Watchlist",
      "raceCentre": "Race Centre",
      "results": "Overview",
      "rankings": "Rankings",
      "seasons": "Season Snapshot",
      "hallOfFame": "Hall of Fame",
      "profile": "Settings",
      "pro": "Pro",
      "help": "Help",
      "contact": "Contact",
      "rules": "Rules",
      "patchNotes": "Patch Notes",
      "roadmap": "Roadmap",
      "logout": "Log out",
      "admin": "Admin",
      "growth": "Growth",
      "fairplay": "Fair play",
      "valueTransition": "Value transition",
      "valuePreview": "Value preview",
      "survey": "Survey"
    }
  },
  "sidebar": {
    "balance": "Balance",
    "balanceTooltip": "CZ$ is the in-game currency. You earn it by playing, and it cannot be bought with real money.",
    "division": "Division {division}",
    "divisionTooltip": "Your league tier. Division 1 is the top tier, Division 4 the entry tier.",
    "onlineNow": "{count} online now",
    "joinDiscord": "Join Discord"
  },
  "language": {
    "label": "Language",
    "danish": "Dansk",
    "english": "English",
    "fr": "Français",
    "es": "Español",
    "nl": "Nederlands",
    "switchTooltip": "Change language",
    "betaBadge": "Beta",
    "betaNote": "Missing texts are shown in English."
  },
  "actions": {
    "cancel": "Cancel",
    "save": "Save",
    "close": "Close",
    "hide": "Hide",
    "clickToClose": "Click to close",
    "loading": "Loading…",
    "loadingShort": "…",
    "success": "✓",
    "error": "Error"
  },
  "time": {
    "justNow": "Just now",
    "minutesAgo": "{m}m ago",
    "hoursAgo": "{h}h ago",
    "daysAgo": "{d}d ago",
    "onlineNow": "Online now",
    "never": "Never"
  },
  "controls": {
    "watchlistAdd": "Add to watchlist",
    "watchlistRemove": "Remove from watchlist",
    "compareSelect": "Select for comparison",
    "compareRemove": "Remove from comparison",
    "compareMax": "Max {max} riders can be compared",
    "compareButton": "Compare",
    "compareSelectedLabel": "selected",
    "compareMinHint": "(select at least 2)",
    "clear": "Clear",
    "noFilterResults": "No riders match your filters",
    "clearFilters": "Clear all filters",
    "statsToggleButton": "Show stats",
    "statsToggleHeading": "Stats",
    "statsToggleShowAll": "Show all",
    "statsToggleHideAll": "Hide all"
  },
  "a11y": {
    "openMenu": "Open menu",
    "openNotifications": "Inbox",
    "removeFromComparison": "Remove from comparison",
    "saveNote": "Save note",
    "searchHelp": "Search help and FAQ",
    "selectSeason": "Select season",
    "unreadPatchNotes": "New patch notes",
    "unreadForum": "New forum activity",
    "unreadRoadmap": "New roadmap items",
    "selectionReminder": "Squad selection missing before the deadline",
    "selectionReminderUrgent": "Your team will not start"
  },
  "leaderBadge": "Leader",
  "betaBadge": "Beta",
  "amountInput": {
    "invalid": "Enter a whole number, e.g. 150000 or 150.000",
    "parsedPreview": "= {amount} CZ$"
  },
  "table": {
    "fullTable": "Full table",
    "columnsLabel": "Choose columns",
    "moreRight": "More columns to the right"
  },
  "networkError": "Can't reach the server right now. Check your connection and try again.",
  "push": {
    "title": "Push notifications",
    "subtitle": "I only ping you when it matters. Never between 22:00 and 08:00, and at most 6 a day.",
    "enable": "Turn on push",
    "disable": "Turn off on this device",
    "statusOn": "On for this device",
    "denied": "Your browser blocks notifications from Cycling Zone. Allow them in the site settings, then try again.",
    "iosInstall": "On iPhone and iPad, push works once Cycling Zone is on your home screen: tap Share, then Add to Home Screen.",
    "unsupported": "This browser can't receive push notifications.",
    "error": "That didn't work. Try again.",
    "categoriesHeading": "What I send",
    "category": {
      "auctions": { "label": "Auctions, last minute", "desc": "Outbid just before the end, and won." },
      "races": { "label": "Races", "desc": "One summary per race day." },
      "transfers": { "label": "Transfer offers", "desc": "An offer is waiting for your answer." },
      "deadlines": { "label": "Squad and deadlines", "desc": "Deadlines that cost you if you miss them." },
      "academy": { "label": "Academy and training", "desc": "Only in the morning summary." }
    },
    "offer": {
      "regionAriaLabel": "Push notifications",
      "title": "Want a ping if you're outbid before the end?",
      "accept": "Yes, ping me",
      "later": "Not now",
      "done": "Done. Change it any time under Profile, Notifications."
    }
  }
}
